// src/components/ui/FloatingWhatsApp.jsx
import React from 'react';
import { BUSINESS_INFO } from '../../utils/constants';
import WhatsAppIcon from './WhatsAppIcon';

const FloatingWhatsApp = () => {
  return (
    <div className="floating-whatsapp">
      <a
        href={BUSINESS_INFO.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <div className="floating-whatsapp-ping"></div>
        <button className="floating-whatsapp-btn" aria-label="Open WhatsApp chat">
          <WhatsAppIcon size={30} />
        </button>
        <div className="floating-whatsapp-tooltip">
          Chat with us on WhatsApp
        </div>
      </a>
    </div>
  );
};

export default FloatingWhatsApp;